/**
 * Utilidad para construir URLs de imágenes correctas
 * Maneja tanto URLs absolutas como rutas relativas del backend
 */

/**
 * Construye una URL completa para una imagen, manejando rutas relativas del backend
 * @param imagePath - Ruta de la imagen (puede ser relativa o absoluta)
 * @returns URL completa de la imagen o string vacío si no hay imagen
 */
export const getImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) return ''

  // Si ya es una URL completa, devolverla tal como está
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath
  }

  // Si es un path relativo, construir URL completa con base del backend
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'
  return `${baseUrl}${imagePath}`
}

/**
 * Construye URLs para un array de imágenes
 * @param imagePaths - Array de rutas de imágenes
 * @returns Array de URLs completas
 */
export const getImageUrls = (imagePaths: (string | null | undefined)[]): string[] => {
  return imagePaths
    .filter((path): path is string => !!path)
    .map(path => getImageUrl(path))
}